export default {
    title: "Confirmation de livraison",
    header: "@:views.survey.delivery.title",
    result: {
        header: "Merci",
        message: "Merci pour votre réponse."
    },
    status: {
        yes: "Veuillez vérifier les produits sélectionnés ci-dessous pour confirmer la livraison et décocher ceux que vous n'avez pas reçus. Cliquez ensuite sur « Envoyer » pour confirmer.",
        no: "Veuillez vérifier que vous n'avez reçu aucun des produits ci-dessous. Si vous avez reçu l'un de ces produits, veuillez cocher la case correspondant au(x) produit(s) reçu(s) et cliquer sur « Envoyer » pour confirmer."
    },
    model: {
        checked: {
            label: "Reçu"
        }
    },
    button: {
        submit: {
            cta: "Soumettre",
            processing: "Soumission"
        }
    }
}